import { render, staticRenderFns } from "./WsLogTable.vue?vue&type=template&id=395cf137&"
import script from "./WsLogTable.vue?vue&type=script&lang=js&"
export * from "./WsLogTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports